import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/Admin/admin.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-dashboard-access',
  templateUrl: './dashboard-access.component.html',
  styleUrls: ['./dashboard-access.component.css']
})
export class DashboardAccessComponent implements OnInit {

  DashboardAccessList=[];
  Submitted=false;
  AllUserTypeList=[];

  constructor(private adminservice: AdminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    DasboardAccessModel = {
      UserTypeID: 0,
      IsTodayDate: false,
      IsTotalStudent: false,
      IsTotalStaff: false,
      IsTotalClass: false,
      IsStudentBirthday: false,
      IsStaffBirthday: false,
      IsStudentAttendance: false,
      IsStaffAttendance: false,
      IsTotalCollection: false,
      IsTotalTC: false,
      IsBookLib: false,
      IsTotalSubject: false,
      IsStudentReport: false,
      IsCoschReport: false,
      IsHealthReport: false,
      IsResultAnalysis: false,
      IsNotice: false,
      IsEvent: false,
      IsCircular: false,
      IsHoliday: false,
      IsStudentProfile: false,
      IsStudentHomeWork: false,
      IsStudentAttendanceDetails: false,
      IsStudentFeeDetail: false,
      IsStudentLibraryDetails: false,
      IsStudentAcademics: false,
  }

  GetDashboardAccess() {
      this.ClearModel();
     this.spinnerService.show();
      this.adminservice.GetDashboardAccess(JSON.stringify(this.DasboardAccessModel)).subscribe((data: any) => {
          this.DashboardAccessList = data.DashboardAccessList;
          if (this.DashboardAccessList != null && this.DashboardAccessList.length>0) {
              this.DasboardAccessModel.IsTodayDate = this.DashboardAccessList[0].IsTodayDate;
              this.DasboardAccessModel.IsTotalStudent = this.DashboardAccessList[0].IsTotalStudent;
              this.DasboardAccessModel.IsTotalStaff = this.DashboardAccessList[0].IsTotalStaff;
              this.DasboardAccessModel.IsTotalClass = this.DashboardAccessList[0].IsTotalClass;
              this.DasboardAccessModel.IsStudentBirthday = this.DashboardAccessList[0].IsStudentBirthday;
              this.DasboardAccessModel.IsStaffBirthday = this.DashboardAccessList[0].IsStaffBirthday;
              this.DasboardAccessModel.IsStudentAttendance = this.DashboardAccessList[0].IsStudentAttendance;
              this.DasboardAccessModel.IsStaffAttendance = this.DashboardAccessList[0].IsStaffAttendance;
              this.DasboardAccessModel.IsTotalCollection = this.DashboardAccessList[0].IsTotalCollection;
              this.DasboardAccessModel.IsTotalTC = this.DashboardAccessList[0].IsTotalTC;
              this.DasboardAccessModel.IsBookLib = this.DashboardAccessList[0].IsBookLib;
              this.DasboardAccessModel.IsTotalSubject = this.DashboardAccessList[0].IsTotalSubject;
              this.DasboardAccessModel.IsStudentReport = this.DashboardAccessList[0].IsStudentReport;
              this.DasboardAccessModel.IsCoschReport = this.DashboardAccessList[0].IsCoschReport;
              this.DasboardAccessModel.IsHealthReport = this.DashboardAccessList[0].IsHealthReport;
              this.DasboardAccessModel.IsResultAnalysis = this.DashboardAccessList[0].IsResultAnalysis;
              this.DasboardAccessModel.IsNotice = this.DashboardAccessList[0].IsNotice;
              this.DasboardAccessModel.IsEvent = this.DashboardAccessList[0].IsEvent;
              this.DasboardAccessModel.IsCircular = this.DashboardAccessList[0].IsCircular;
              this.DasboardAccessModel.IsHoliday = this.DashboardAccessList[0].IsHoliday;
              this.DasboardAccessModel.IsStudentProfile = this.DashboardAccessList[0].IsStudentProfile;
              this.DasboardAccessModel.IsStudentHomeWork = this.DashboardAccessList[0].IsStudentHomeWork;
              this.DasboardAccessModel.IsStudentAttendanceDetails = this.DashboardAccessList[0].IsStudentAttendanceDetails;
              this.DasboardAccessModel.IsStudentFeeDetail = this.DashboardAccessList[0].IsStudentFeeDetail;
              this.DasboardAccessModel.IsStudentLibraryDetails = this.DashboardAccessList[0].IsStudentLibraryDetails;
              this.DasboardAccessModel.IsStudentAcademics = this.DashboardAccessList[0].IsStudentAcademics;
          }
          this.spinnerService.hide();
      });
  }
 
  Clear() {
   
      this.DasboardAccessModel = {
          UserTypeID: 0,
          IsTodayDate: false,
          IsTotalStudent: false,
          IsTotalStaff: false,
          IsTotalClass: false,
          IsStudentBirthday: false,
          IsStaffBirthday: false,
          IsStudentAttendance: false,
          IsStaffAttendance: false,
          IsTotalCollection: false,
          IsTotalTC: false,
          IsBookLib: false,
          IsTotalSubject: false,
          IsStudentReport: false,
          IsCoschReport: false,
          IsHealthReport: false,
          IsResultAnalysis: false,
          IsNotice: false,
          IsEvent: false,
          IsCircular: false,
          IsHoliday: false,
          IsStudentProfile: false,
          IsStudentHomeWork: false,
          IsStudentAttendanceDetails: false,
          IsStudentFeeDetail: false,
          IsStudentLibraryDetails: false,
          IsStudentAcademics: false,
      }
      this.Submitted = false;


  }
  ClearModel() {
      this.DasboardAccessModel.IsTodayDate = false;
      this.DasboardAccessModel.IsTotalStudent = false;
      this.DasboardAccessModel.IsTotalStaff = false;
      this.DasboardAccessModel.IsTotalClass = false;
      this.DasboardAccessModel.IsStudentBirthday = false;
      this.DasboardAccessModel.IsStaffBirthday = false;
      this.DasboardAccessModel.IsStudentAttendance = false;
      this.DasboardAccessModel.IsStaffAttendance = false;
      this.DasboardAccessModel.IsTotalCollection = false;
      this.DasboardAccessModel.IsTotalTC = false;
      this.DasboardAccessModel.IsBookLib = false;
      this.DasboardAccessModel.IsTotalSubject = false;
      this.DasboardAccessModel.IsStudentReport = false;
      this.DasboardAccessModel.IsCoschReport = false;
      this.DasboardAccessModel.IsHealthReport = false;
      this.DasboardAccessModel.IsResultAnalysis = false;
      this.DasboardAccessModel.IsNotice = false;
      this.DasboardAccessModel.IsEvent = false;
      this.DasboardAccessModel.IsCircular = false;
      this.DasboardAccessModel.IsHoliday = false;
      this.DasboardAccessModel.IsStudentProfile = false;
      this.DasboardAccessModel.IsStudentHomeWork = false;
      this.DasboardAccessModel.IsStudentAttendanceDetails = false;
      this.DasboardAccessModel.IsStudentFeeDetail = false;
      this.DasboardAccessModel.IsStudentLibraryDetails = false;
      this.DasboardAccessModel.IsStudentAcademics = false;

  }
 

  CheckUser() {
      return this.DasboardAccessModel.UserTypeID == 0;
  }
 
  SaveDashboardAccess() {
      this.Submitted = true;
      if (!this.CheckUser()) {
         this.spinnerService.show();
          this.adminservice.SaveDashboardAccess(JSON.stringify(this.DasboardAccessModel)).subscribe((data: any) => {
              this.globalHelper.CheckActionStatus(data);
              this.spinnerService.hide();
              this.GetDashboardAccess();             
          });
      }
  }
  ngOnInit() {
    this.GetAllUserType();
  }

  GetAllUserType() {
   
    this.lookupservice.GetLookupsList('DashBoardUserType', '').subscribe((data: any) => {
        this.AllUserTypeList = data.LookupItems;
       
    });
}

}
